import closeBannerAction from 'modules/banner/actions/close'
import {
  addEditingAction,
  removeEditingAction
} from 'modules/editing/actions'
import REDUX_ACTION from 'modules/redux/constants/action'
import REDUX_OPTION from 'modules/redux/constants/option'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { formatInstanceBeforeUpdate } from 'models/formatters/before-update'
import getDomainPathFromPathReduxUtil from 'modules/redux/utils/get-domain-path-from-path'
import { REDUX_DOMAIN } from 'modules/redux/constants'
import { getObjectUtil } from 'packages/src'

/**
 * When an update is made on one of these modules, it hides the banner.
 * @type {String[]}
 */
const REDUX_DOMAINS_ON_UPDATE_HIDE_BANNER = [
  REDUX_DOMAIN.ADDRESS,
  REDUX_DOMAIN.ARTICLES,
  REDUX_DOMAIN.CREDENTIAL,
  REDUX_DOMAIN.CATEGORIES,
  REDUX_DOMAIN.MOTIVATION,
  REDUX_DOMAIN.PAGES,
  REDUX_DOMAIN.PRODUCTS,
  REDUX_DOMAIN.USERS
]

/**
 * Formats the given instance's value.
 * @private
 * @param  {Instance} instance
 * @param  {string} key
 * @param  {*} value
 * @returns {*}
 */
function formatUpdatedValue (instance, key, value) {
  // Get the previous value
  const previousValue = getValueReduxUtil(instance, key)
  const previousData = { [key]: previousValue }
  let data = { [key]: value }
  data = formatInstanceBeforeUpdate({
    data,
    className: instance.className,
    previousData
  })
  return data[key]
}

/**
 * Checks whether the update of
 * the given path's domain should hide the banner.
 * @param  {string} path
 * @returns {boolean}
 */
function shouldHideBanner (path) {
  const domain = getDomainPathFromPathReduxUtil(path)
  return REDUX_DOMAINS_ON_UPDATE_HIDE_BANNER.includes(domain)
}

/**
 * Updates the instance's given key with the given value.
 * it formats the given data by calling the `beforeUpdate` hook

 * @param  {Object}  params
 *         {string}  params.path
 *         {*}  params.value
 *         {string}  [params.key]
 *         {boolean}  [params.isLocal]
 *         {boolean}  [params.options={}]
 * @returns {Function}
 */
function updateLegacyReduxAction (params) {
  return (dispatch, getState) => {
    let {
      path,
      key,
      value,
      isLocal,
      options = {}
    } = params
    // If it's updating a instance, format the given value
    if (key) {
      // Get the instance
      const instance = getObjectUtil(getState(), path)
      // Format the value
      value = formatUpdatedValue(instance, key, value)
      // If the `value` and the `key` is not required, delete it
      // It will avoid to get it validated
      // if (
      //   !value &&
      //   !isRequiredModelUtil(instance.className, key) &&
      //   !instance.data[key]
      // ) {
      //   value = undefined
      // }
      if (value && !isLocal && !options[REDUX_OPTION.OMIT_EDITING]) {
        dispatch(
          addEditingAction(path)
        )
      }
    } else {
      // Reset the editing domain if necessary
      dispatch(
        removeEditingAction(path)
      )
    }
    // Hide the banner if necessary
    if (shouldHideBanner(path)) {
      dispatch(
        closeBannerAction()
      )
    }
    return dispatch({
      type: REDUX_ACTION.UPDATE,
      payload: {
        path,
        key,
        value,
        isLocal
      }
    })
  }
}

export {
  updateLegacyReduxAction
}
